import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { SingleDatePickerField, SingleDatePickerFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys, MarketplaceFormValues } from '../types';

export const PostTrackingEndDateField = <T extends string = keyof typeof MarketplaceFormKeys>({
  name,
  required,
  ...restProps
}: Partial<SingleDatePickerFieldProps<T>>) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();

  const periodValue = watch(MarketplaceFormKeys.period);

  return (
    <SingleDatePickerField<T>
      help={t('Tooltip.postTrackingEndDateHelp')}
      title={t('Tracking End Date')}
      required={required}
      optional={!required}
      disabledDays={{ before: new Date(periodValue?.endDate || periodValue?.startDate || '') }}
      name={name || (MarketplaceFormKeys.postTrackingEndDate as T)}
      {...restProps}
    />
  );
};
